import { Component, OnInit, ViewChild } from '@angular/core';
import {
  MatPaginator, MatTableDataSource,
  MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatSlideToggleModule, MatSnackBar, MatSort
} from '@angular/material';
import { CustomerService } from 'src/app/services/customer/customer.service';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import { EditcustomerComponent } from '../editcustomer/editcustomer.component';
import { FleetService } from 'src/app/services/fleet/fleet.service';
import { TokenStorage } from 'src/app/auth/token.storage';

@Component({
  selector: 'app-allcustomers',
  templateUrl: './allcustomers.component.html',
  styleUrls: ['./allcustomers.component.scss']
})
export class AllcustomersComponent implements OnInit {
  customerDataArray = new MatTableDataSource();
  isTenantDiag: any = false;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  columnsToDisplay = [
    'customerName',
    'customerCode',
    'customerType',
    'city',
    'zone',
    'edit',
    'userActive'
  ];

  constructor(private dialog: MatDialog,
    private customerService: CustomerService,
    private fleetService: FleetService,
    private token: TokenStorage,
  ) {
    if (this.token.getCustomerType() === 'Diagnostic') {
      this.isTenantDiag = true;
    }
  }

  ngOnInit() {
    this.customerService.getAllCustomers().subscribe(allCustomers => {
      console.log("all", allCustomers)
      this.customerDataArray.data = allCustomers;

    });
    this.customerDataArray.paginator = this.paginator;
    this.customerDataArray.sortingDataAccessor = (item: any, property) => {
      switch (property) {
        case 'customerName': return item.customerName;
      }
    };
    this.customerDataArray.sort = this.sort;
  }

  applyFilter(filterValue: string) {
    this.customerDataArray.filter = filterValue.trim().toLowerCase();
  }

  editCustomer(customer) {
    let editDialog = this.dialog.open(EditcustomerComponent, {
      width: '800px',
      data: customer
    });
    editDialog.updatePosition({
      top: '50px', right: '0px',
    });
  }

  onChange(event, customerId: number) {
   this.customerService.activateCustomer(customerId, event.checked).subscribe(activated => {
    console.log(activated);    
    },Error=>{
      console.log("Error in adding customer");
    })
  }
}
